import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const rentalOrderCountWidget: DashboardWidgetConfiguration = {
  widgetId: "rental.order-count",
  name: "Rental orders",
  description: "Rental orders for the selected dashboard period.",
  apps: [
    "rental",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "rental.orders",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "order_id",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Rental orders",
    subtext: "in the last 30 days",
    icon: "orders",
    color: "primary",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 0,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
